import {
  Component,
  Input,
  OnInit,
  ElementRef,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss'],
})
export class HintComponent implements OnInit {
  @Input() hintData!: any;
  @Input() displayCss: string = 'block';
  @Input() iconSrc: string = '/resultpage/assets/icons/QUESTION_MARK.svg';
  @ViewChild('hint') hint: ElementRef<HTMLInputElement>;
  @ViewChild('popup') popup: ElementRef<HTMLInputElement>;

  constructor(private render: Renderer2) {}

  ngOnInit(): void {}

  showPopup(event: MouseEvent | TouchEvent): void {
    event.stopPropagation();
    this.checkHintPosition();
  }

  checkHintPosition(): void {
    const popup = this.popup.nativeElement;

    if (window.innerWidth < 1020) {
      this.render.addClass(popup, 'leftPosition');
      this.render.removeClass(popup, 'rightPosition');
      return;
    }

    const widthWindow =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    const leftPosition = this.hint.nativeElement.getBoundingClientRect().left;
    const center = widthWindow / 2;

    if (leftPosition <= center) {
      this.render.addClass(popup, 'rightPosition');
      this.render.removeClass(popup, 'leftPosition');
    } else {
      this.render.addClass(popup, 'leftPosition');
      this.render.removeClass(popup, 'rightPosition');
    }
  }

  trackByHint(index: number, option: { title?: string; text?: string }) {
    return `${option?.title ?? ''}-${option?.text ?? ''}-${index}`;
  }
}
